import { Component, OnInit } from '@angular/core';
import {BatchCallList} from '../../../model/batch-call-list';
import { Router} from '@angular/router'
import { VoiceBatchService } from '../../../service/voice/voice-batch.service';
//import 'rxjs/add/operator/debounceTime';

@Component({
  selector: 'voice-batch-table',
  templateUrl: './voice-batch-table.component.html',
  styleUrls: ['./voice-batch-table.component.scss']
})
export class VoiceBatchTableComponent implements OnInit {

  protected maxItemsPerPage: number;
  protected page: number;
  protected total: number;

  protected keyword: string;

  private batch_calls:BatchCallList[] = [];
  private loading:boolean = false;

  constructor(private vbs: VoiceBatchService,private route:Router) { 
    this.initializeComponents();
  }

  private initializeComponents() {
    this.maxItemsPerPage = 5;
    this.page = 1;
    this.keyword = '';
  }

  ngOnInit() {
    this.getBatch(this.maxItemsPerPage,this.page,this.keyword)
}


getBatch(maxItemsPerPage:number,page: number,keyword:string){
  this.loading = true;
  
  this.vbs.getVoiceBatch(maxItemsPerPage,page,keyword)
  .subscribe(
    (data: any) => {
      this.reassignVariables(data);
    },
    (err) => alert('Error fetching data:' + JSON.stringify(err)),
    () => {
      this.loading = false;
    }
  )
}

reassignVariables(data){
  this.batch_calls = data.data.data;
  this.total = data.data.total;
}

gotoBatchDetail(batch_id){
  this.route.navigate([
    '/joytogive/voicedetail',{id:batch_id}
  ]);
}

}
